export const PENDING_JOB_APPLICATION_APPLICANT_NOTIFICATION =
  "PendingJobApplicationApplicantNotification";
export type PENDING_JOB_APPLICATION_APPLICANT_NOTIFICATION_TYPE = "PendingJobApplicationApplicantNotification";
export const APPROVED_JOB_APPLICATION_APPLICANT_NOTIFICATION =
  "ApprovedJobApplicationApplicantNotification";
export type APPROVED_JOB_APPLICATION_APPLICANT_NOTIFICATION_TYPE = "ApprovedJobApplicationApplicantNotification";
export const REJECTED_JOB_APPLICATION_APPLICANT_NOTIFICATION =
  "RejectedJobApplicationApplicantNotification";
export type REJECTED_JOB_APPLICATION_APPLICANT_NOTIFICATION_TYPE = "RejectedJobApplicationApplicantNotification";
export const APPROVED_PROFILE_APPLICANT_NOTIFICATION = "ApprovedProfileApplicantNotification";
export type APPROVED_PROFILE_APPLICANT_NOTIFICATION_TYPE = "ApprovedProfileApplicantNotification";
export const REJECTED_PROFILE_APPLICANT_NOTIFICATION = "RejectedProfileApplicantNotification";
export type REJECTED_PROFILE_APPLICANT_NOTIFICATION_TYPE = "RejectedProfileApplicantNotification";
